import React, { useEffect, useState } from "react";
import "./EventAccommodation.scss";
import { Checkbox, Form, Input, InputNumber, Select, Switch } from "antd";
import { getRoomType } from "../../services/RoomTypeService";
import { AxiosError, AxiosResponse } from "axios";
import { ShortRoomType, UpdateRoomType } from "../../models/RoomType";
import { UpdateAccommodationDto } from "../../models/Accommodation";
import { UpdateEventXRoomTypeCreate } from "../../models/EventXRoomTypeDto";
import { DeleteOutlined } from "@ant-design/icons";

const RoomTypeInEvent = (props: any) => {
  const [id, setId] = useState("");
  const [oneRoomType, setOneRoomType] = useState<ShortRoomType>();

  const accommodationFields = props.form.getFieldValue("accommodations");

  const Option = Select.Option;

  useEffect(() => {
    if (id === "") return;
    getRoomType(id)
      .then((response: AxiosResponse) => {
        let data = response.data.result;

        let oneRoomType = {
          id: data.id,
          name: data.name,
          note: data.note,
          price: data.price,
          capacity: data.capacity,
          totalNumber: data.roomsTotalNumber,
          accommodation: data.accommodation,
          roomType: { id: data.id },
        };
        const fields = props.form.getFieldsValue();
        const { accommodations } = fields;

        setOneRoomType(oneRoomType);

        accommodations.find((accomodation: UpdateAccommodationDto | any) => {
          return accomodation?.roomTypes.some((roomType: UpdateRoomType) => {
            if (roomType.name == oneRoomType.id) {
              let deletedIdFromArr = accomodation?.roomTypes?.filter(
                (oneRT: UpdateRoomType) => oneRT.name !== oneRoomType.id
              );
              let newAcc = accomodation;
              newAcc.roomTypes = [...deletedIdFromArr, oneRoomType];
              return newAcc;
            }
          });
        });
      })
      .catch((err: AxiosError) => console.log(err));
  }, [id]);

  const handleDropdown = (oneRoomType: string) => {
    setId(oneRoomType);
  };

  return (
    <div className="event-accommodation-roomType">
      <div className="roomType-event">
        <span>
          <Form.Item
            {...props.restField}
            name={[props.name, "name"]}
            label="Soba:"
            rules={[
              {
                required: true,
                message: "Potrebno je izabrati smeštaj!",
              },
            ]}
          >
            <Select onChange={handleDropdown} placeholder="Izaberite sobu">
              {props?.oneAccommodation?.roomType?.map(
                (oneRoomType: UpdateRoomType, i: number) => {
                  return (
                    <Option
                      disabled={accommodationFields?.find(
                        (accommodation: UpdateAccommodationDto) => {
                          let oneRT =
                            accommodation?.roomTypes == undefined
                              ? []
                              : accommodation?.roomTypes;
                          return oneRT?.some(
                            (roomType: UpdateEventXRoomTypeCreate) => {
                              if (roomType?.createdAt) {
                                return (
                                  roomType?.roomType?.id == oneRoomType?.id
                                );
                              }
                              return roomType?.id == oneRoomType?.id;
                            }
                          );
                        }
                      )}
                      key={oneRoomType.id}
                      value={oneRoomType.id}
                    >
                      {oneRoomType.name}
                    </Option>
                  );
                }
              )}
            </Select>
          </Form.Item>
          <Form.Item name={[props.name, "totalNumber"]} label="Broj soba:">
            <Input className="input-label" type="number" min={1} />
          </Form.Item>
        </span>
        <span>
          <Form.Item
            {...oneRoomType}
            name={[props.name, "capacity"]}
            label="Kapacitet:"
          >
            <Input className="input-label" type="number" disabled />
          </Form.Item>

          <Form.Item
            name={[props.name, "price", "priceForRoom"]}
            label="Cena po sobi:"
            rules={[
              {
                required: true,
                message: "Potrebno je unijeti cijenu po sobi!",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
            />
          </Form.Item>
        </span>
        <span>
          <Form.Item
            name={[props.name, "priceForPerson"]}
            label="Cena po osobi:"
            valuePropName="checked"
            className="switch-antd-rt"
          >
            <Switch className="input-label" />
          </Form.Item>

          <Form.Item
            name={[props.name, "totalNumberRoomForSite"]}
            label="Broj soba na sajtu:"
            rules={[
              {
                required: true,
                message: "Potrebno je uneti broj soba na sajtu!",
              },
            ]}
          >
            <Input className="input-label" type="number" min={0} />
          </Form.Item>
        </span>

        <span className="priceForPerson">
          {accommodationFields?.map(
            (accommodation: UpdateAccommodationDto, index: number) => {
              if (index === props.nameAccommodations) {
                return accommodation?.roomTypes?.map(
                  (
                    roomType: UpdateRoomType | UpdateEventXRoomTypeCreate,
                    ii: number
                  ) => {
                    if (ii === props?.name) {
                      return (
                        roomType?.price !== undefined &&
                        Object?.entries(roomType?.price)
                          ?.filter(([key, _]) => key !== "priceForRoom")
                          ?.map(([key, value], index) => {
                            const defaultValue =
                              typeof value === "string" ||
                              typeof value === "number"
                                ? value
                                : undefined;

                            return (
                              <Form.Item
                                key={`${roomType.id}-${key}`}
                                name={[props.name, "price", key]}
                                label={`Cena za ${index + 1}. osobu:`}
                                rules={[
                                  {
                                    required: true,
                                    message: `Potrebno je uneti cenu za ${key}!`,
                                  },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  defaultValue={defaultValue}
                                  formatter={(value) =>
                                    `${value}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ","
                                    )
                                  }
                                  parser={(value) =>
                                    value!.replace(/\$\s?|(,*)/g, "")
                                  }
                                />
                              </Form.Item>
                            );
                          })
                      );
                    }
                  }
                );
              }
            }
          )}
        </span>

        <div className="paring-spot">
          <span className="parking-input">
            <Form.Item
              name={[props.name, "parkingPlace"]}
              label="Parking mesto:"
              valuePropName="checked"
            >
              <Checkbox className="input-label" type="checkbox" />
            </Form.Item>
          </span>
          <div className="footer-agenda">
            <span className="btn">
              <DeleteOutlined onClick={() => props.remove(props.name)} />
            </span>
          </div>
        </div>
      </div>

      <div className="night-div">
        <Form.Item
          name={[props.name, "priceForNight"]}
          // rules={[
          //   {
          //     required: true,
          //     type: "object",
          //     message: "Potrebno je uneti cene za noćenja!",
          //   },
          // ]}
        >
          {Array.from(
            { length: props.selectedRange as number },
            (_, index) => index + 1
          ).map((index) => {
            const fieldName = `priceFor${index}Night`;

            return (
              <div key={`div-${index}`}>
                <Form.Item
                  label={`Cena za ${index} ${index > 1 ? "noći:" : "noć:"}`}
                  key={`form-${fieldName}`}
                  name={[props.name, "priceForNight", fieldName]}
                  rules={[
                    {
                      required: true,
                      message: "Potrebno je uneti cenu za broj noćenja!",
                    },
                  ]}
                  style={{ marginRight: "10px" }}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder={`Unesite cenu za ${index}. noć`}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            );
          })}
        </Form.Item>
      </div>

      {/* <Form.Item
        className="notes"
        name={[props.name, "note"]}
        label="Napomena za sobu:"
      >
        <Input className="input-label" type="text" />
      </Form.Item> */}
    </div>
  );
};

export default RoomTypeInEvent;
